const AccountSettings_en = {
  ID_SETTING_TITLE: "Account Setting",
  ID_SETTING_TAB_01: "Manage Account",
  ID_SETTING_TAB_02: "Change Password",
  ID_SETTING_TAB_03: "Manage SNS accounts",
  ID_SETTING_ID: "ID",
  ID_SETTING_PWD: "Password",
  ID_SETTING_BIRTH: "Date of Birth",
  ID_SETTING_NICKNAME: "Nickname",
  ID_SETTING_EMAIL: "Email address",
  ID_SETTING_PHONE: "Mobile Number",
  ID_SETTING_GENDER: "Sex",
  ID_SETTING_MARKETING_AGREEMENT: "I agree to {link}",
  ID_SETTING_MARKETING_LINK: "Receive marketing information",
  ID_SETTING_SAVE: "Save",
  ID_SETTING_EDIT: "Edit",
  ID_SETTING_APPLY: "Register",
  ID_SETTING_FEMALE: "Female",
  ID_SETTING_MALE: "Male",
  ID_SETTING_NOSELECT: "Not specified",
  ID_SETTING_NOEMAIL: "No authenticated email address.",
  ID_SETTING_NOPHONE: "No authenticated mobile number.",
  ID_SETTING_LEAVE_REDBRICK: "Redbrick membership withdrawal",
  ID_SETTING_SENDING: "Sending...",

  // 비밀번호 변경
  ID_SETTING_CURR_PWD: "Enter current password",
  ID_SETTING_NEW_PWD: "Enter new password",
  ID_SETTING_CONFIRM_PWD: "Enter password again",
  ID_SETTING_CHANGE_PWD: "Change Password",
  ID_SETTING_PWD_PATTERN: "letters and numbers",
  ID_SETTING_PWD_LENGTH: "Minimum 8 letters",
  ID_SETTING_PWD_EMPTY_ERR: "Please enter current password.",
  ID_SETTING_PWD_CURR_WRONG:
    "Please enter your current password correctly for account security.",
  ID_SETTING_PWD_NON_MATCH: "Password does not match.",
  ID_SETTING_CHANGE_SUCCESS: "Password changed successfully!",
  ID_SETTING_SUCCESS_BTN: "Confirm",
  ID_SETTING_CHANGE_INFO_SUCCESS:
    "Account settings\nhave been changed successfully.",

  //휴대폰 등록
  ID_SETTING_PHONE_TITLE: "Register Mobile Number",
  ID_SETTING_PHONE_SUBTITLE:
    "Please authenticate the mobile number to be registered in your account.",

  ID_SETTING_PHONE_NUM_PLACEHOLDER: "Enter mobile number",
  ID_SETTING_PHONE_CODE_PLACEHOLDER: "Enter authentication code",
  ID_SETTING_PHONE_VERIFY_BUTTON: "Authenticate",
  ID_SETTING_PHONE_SUCCESS: "The mobile number has been authenticated.",
  ID_SETTING_PHONE_WRONG_NUM: "Enter correct mobile number",
  ID_SETTING_PHONE_DUPLICATE:
    "This mobile number is already registered. Please enter a different mobile number.",
  ID_SETTING_PHONE_CODE_ERR: "The authentication code is incorrect.",
  ID_SETTING_PHONE_CODE_ERR_TIMEOUT:
    "The authentication code has expired. Please resend code.",
  ID_SETTING_PHONE_CODE_SUCCESS: "Authentication Complete",
  ID_SETTING_VERIFY_COMPLETE: "Authentication Complete",
  ID_SETTING_VERIFY_WAIT: "Waiting for authentication...",
  ID_SETTING_PHONE_SAVE: "The mobile number has been saved.",

  //이메일 등록
  ID_SETTING_EMAIL_TITLE: "Register Email",
  ID_SETTING_PARENT_VERIFY: "Your guardian's email authentication is required.",
  ID_SETTING_EMAIL_EMPTY_ERR: "Please enter email address.",
  ID_SETTING_EMAIL_SUBTITLE:
    "Please register your guardian email for account protection and youth privacy! If email not registered, you can't find your ID and password.",
  ID_SETTING_EMAIL_PLACEHOLDER: "ex)redbrick.official@redbrick.space",
  ID_SETTING_EMAIL_CODE_PLACEHOLDER: "Please enter authentication code.",
  ID_SETTING_EMAIL_VERIFY_BUTTON: "Send Mail",
  ID_SETTING_EMAIL_SUCCESS: "The email has been autheniticated.",
  ID_SETTING_EMAIL_CODE_ERR:
    "The authentication code is incorrect. Please try again.",
  ID_SETTING_EMAIL_CODE_SUCCESS: "Authentication complete",
  ID_SETTING_EMAIL_FORMAT_ERR: "Please enter email address accordingly.",

  //닉네임 수정
  ID_NAME_EDIT_TITLE: "Edit Nickname",
  ID_NAME_EDIT_NICKNAME: "Nickname",
  ID_NAME_OVERLIMIT_ERR:
    "For nicknames, use up to 8 korean letters and 16 english and numeric combination.",
  ID_NAME_DUPLICATE_ERR:
    "This nickname is already in use. Please enter a different nickname.",
  ID_NAME_BADWORD_ERR:
    "The nickname contains a forbidden word. Please enter a different nickname.",
  ID_NAME_PATTERN_ERR: "You can't use blank, special characters in nickname.",

  // 탈퇴 팝업
  ID_SETTING_TERMINATE_CONTENT: "Are you sure\nyou want to terminate?",

  // wallet
  ID_WALLET: "Wallet",
  ID_NO_CONNECTED_WALLET: "There is no associated cryptocurrency wallet.",
  ID_CONNECT_WALLET: "connection",
  ID_DISCONNECT_WALLET: "disconnect",

  // 회원탈퇴
  ID_LEAVE_FUNCTION_TITLE: "Notice of withdrawal",
  ID_LEAVE_NOTICE:
    "Please check the instructions before applying for membership withdrawal.",
  ID_LEAVE_USE_NAME_BOLD: "Your ID({user})",
  ID_LEAVE_NOTICE_2:
    "{value} can be reused if you leave,\nbut you cannot recover existing data.\nPlease choose carefully before leaving.",

  ID_LEAVE_NOTICE_3_BOLD:
    "All membership information and service usage records will be deleted after withdrawal.",
  ID_LEAVE_NOTICE_3:
    "Deleted data is not recovered.\nPlease check the contents below that will be deleted and back up the necessary data in advance.",

  ID_LEAVE_DELETE_LIST_TITLE_1: "Member Information",
  ID_LEAVE_DELETE_LIST_CONTENT_1:
    "Delete ID, nickname, date of birth, email authentication, mobile phone authentication, gender information, and withdrawal of service consent",
  ID_LEAVE_DELETE_LIST_TITLE_2: "Content",
  ID_LEAVE_DELETE_LIST_CONTENT_2:
    "Delete projects, publishing content, and My Asset",
  ID_LEAVE_DELETE_LIST_TITLE_3: "Social",
  ID_LEAVE_DELETE_LIST_CONTENT_3:
    "Delete follow, follower information, and avatar information",
  ID_LEAVE_DELETE_LIST_TITLE_4: "Article",
  ID_LEAVE_DELETE_LIST_CONTENT_4: "Delete posts, comments, likes, etc",
  ID_LEAVE_DELETE_LIST_TITLE_5: "Blockchain",
  ID_LEAVE_DELETE_LIST_CONTENT_5:
    "Delete wallet-linked information associated with the account",

  ID_LEAVE_AFTER_NOTICE:
    "After withdrawal,\nboth you and others can rejoin with {value},\nand your existing data cannot be recovered.",
  ID_LEAVE_AFTER_NOTICE_BOLD: "your ID({user})",
  ID_LEAVE_BEFORE_NOTICE_CHECK:
    "I have checked all the instructions and agree.",

  ID_LEAVE_DOUBLE_CHECK_TITLE:
    "Are you sure you want to leave the membership?\nPlease enter your password to opt out.",

  ID_EMAIL_CHANGE_LEAVE_NOTICE:
    "If you do not use your account by authorized email,\nyou will not be able to use the Redbrick service.",
  ID_EMAIL_CHANGE_SUCCESS_POPUP_TITLE:
    "You have been changed to an authorized email account.\nYou can't use a previous account.\nPlease log in again with the changed email account.",
  ID_EMAIL_CHANGE_HISTORY_BEFORE_LEFT: "Before",
  ID_EMAIL_CHANGE_HISTORY_AFTER_LEFT: "After",
  ID_EMAIL_CHANGE_POPUP_TITLE:
    "Hello, {value}. We're Redbrick.\nDue to the change in the Redbrick account policy,\n{redText}",
  ID_EMAIL_CHANGE_POPUP_RED_TEXT:
    "only certified email accounts will be available from December 1, 2022 (Thursday).",

  ID_EMAIL_CHANGE_POPUP_USER_INDUCE_TEXT:
    "Please enter the email you want to use.",
  ID_EMAIL_CHANGE_POPUP_USER_INDUCE_LOGOUT: "Click 'Confirm' to logout.",

  ID_EMAIL_CHANGE_VALIDATING_INPUT_POPUP_TITLE:
    "The authentication code has been sent to the {user} address you entered.\nPlease check your email.",
  ID_EMAIL_CHANGE_VALIDATING_INPUT_INDUCE_TEXT:
    "Please enter the authentication code.",
  ID_EMAIL_CHANGE_ENTER_PWD_PLACEHOLDER: "Please enter your password.",
  ID_EMAIL_CHANGE_VERIFY_WAITING: "! Waiting for authentication",
  ID_EMAIL_CHANGE_CODE_VERIFY_ERROR:
    "! Please enter the authentication code correctly.",
  ID_EMAIL_CHANGE_VALIDATING_INPUT_SUCCESS_POPUP_TITLE:
    "Email authentication is complete.\nLastly, if you want to use your account with an authenticated email,\nplease enter your existing password again.",
  ID_EMAIL_VALIDATE_FALSE: "! Please enter the authentication code correctly.",
  ID_EMAIL_VALIDATE_FALSE_PASSWORD: "! The password is incorrect.",
  ID_EMAIL_VALIDATE_AGAIN_PASSWORD: "! Please enter your password.",

  ID_LEAVE_SUCCESS_TITLE: "Membership withdrawal complete",
  ID_LEAVE_SUCCESS_SUBTITLE:
    "Thank you for using Redbrick.\nRedbrick will work harder and improve",

  ID_SNS_LOGIN_TERMS_AGREE_TITLE: "Agree to the Terms and Conditions",
  ID_SNS_LOGIN_TERMS_AGREE: "Agree to the full terms and conditions",
  ID_SNS_LOGIN_TERMS_USE: "[Requirement] Terms and Conditions",
  ID_SNS_LOGIN_TERMS_PERSONAL:
    "[Requirement] Consent to collect and use personal information",
  ID_SNS_LOGIN_TERMS_MARKETING:
    "[Select] Agree to receive marketing information",

  ID_SNS_CONNECT_LOGIN_NAVER: "Naver",
  ID_SNS_CONNECT_LOGIN_KAKAO: "Kakao",
  ID_SNS_CONNECT_LOGIN_FACEBOOK: "Facebook",
  ID_SNS_CONNECT_LOGIN_GOOGLE: "Google",
  ID_SNS_CONNECT_LOGIN_MICROSOFT: "MicroSoft",
  ID_SNS_CONNECT_ANOTHER_ACCOUNT: "Do you have\nanother Redbrick account?",
  ID_SNS_CONNECT_ANOTHER_ACCOUNT_SUB_TITLE:
    "Link your Redbrick accounts and manage\nmultiple accounts at once conveniently",
  ID_SNS_CONNECT_ANOTHER_ACCOUNT_EMAIL_PLACEHOLDER:
    "Enter the ID or email of the Redbrick account to be linked to",
  ID_SNS_CONNECT_ANOTHER_ACCOUNT_PASSWORD_PLACEHOLDER:
    "Enter the password for the Redbrick account to be linked with",
  ID_SNS_CONNECT_ACCOUNT_BTN: "Link your account",
  ID_MAIN_BTN: "Main",
  ID_SNS_CONNECT_REDBRICK_ACCOUNT_BTN:
    "Link your social media account to your Redbrick account.",
  ID_SNS_CONNECT_REDBRICK_ACCOUNT_SKIP: "I don't have a Redbrick account.",

  ID_SNS_CONNECT_ACCOUNT_TOOLTIP_TITLE:
    "What's the difference when I link my account?",
  ID_SNS_CONNECT_ACCOUNT_TOOLTIP_CONTENT_1:
    "Once the account is linked, you can see the same information no matter what account you log in with.",
  ID_SNS_CONNECT_ACCOUNT_TOOLTIP_CONTENT_2:
    "The linked account will not be deleted and you can log in the same way as before.",

  ID_ACCOUNT_MANAGE_JOIN: "Team certification",
  ID_ACCOUNT_MANAGE_JOIN_CLEAR: "Disassociation",
  ID_ACCOUNT_JOINED_SSAFY: "Completed SSAFY team certification",
  ID_ACCOUNT_JOINED_CLASS: "Completed CLASS team certification",
  ID_ACCOUNT_JOIN_ERROR: "This is not a valid authentication code.",
};

export default AccountSettings_en;
